var Utility = /** @class */ (function () {
    function Utility() {
    }
    Utility.deleteArrayObject = function (object, objectArr) {
        var index = objectArr.indexOf(object);
        if (index !== -1) {
            objectArr.splice(index, 1);
        }
    };
    return Utility;
}());
export { Utility };
